<div class="flex flex-col flex-1 gap-1">
  <span class="text-base font-medium text-slate-900">{{ item.title }}</span>

  @if ((item.config?.items?.length || 0) > 0) {
    <div class="h-px bg-slate-100"></div>
    <div class="flex flex-col">
      <ng-container
        [ngTemplateOutlet]="templateOutlet"
        [ngTemplateOutletContext]="{
          $implicit: $any(item.config.items),
          groupName: 'report-designer',
          groupTarget: item.config.name,
          scrollable: false,
          cols: '1',
          level: level + 1,
          parentName: item.config.name,
          readOnly: readOnly
        }"
      ></ng-container>
    </div>
  }

  <div class="h-px bg-slate-100"></div>

  <div class="flex flex-col">
    @if (!item.config.tabs || item.config.tabs.length === 0) {
      <div class="flex items-center justify-center">
        <span class="font-light text-slate-600">{{
          "Nessun elemento" | transloco
        }}</span>
      </div>
    }

    @if (item.config.tabs && item.config.tabs.length > 0) {
      <dx-tab-panel
        [dataSource]="tabsDataSource!"
        [focusStateEnabled]="false"
        [(selectedIndex)]="selectedIndex"
      >
        <div
          *dxTemplate="let itemTemplate of 'title'"
          class="flex flex-row items-center group"
        >
          @if (itemTemplate.html) {
            <span>{{ itemTemplate.html }}</span>
          } @else {
            <i class="fa-light fa-folder text-slate-500"></i>
          }
        </div>
        <div *dxTemplate="let itemTemplate of 'item'" class="p-2">
          @if (!itemTemplate.attachments) {
            <div class="flex h-min">
              <ng-container
                [ngTemplateOutlet]="templateOutlet"
                [ngTemplateOutletContext]="{
                  $implicit: itemTemplate.items,
                  groupName: 'report-designer',
                  groupTarget: item.config.name,
                  scrollable: false,
                  cols: '1',
                  level: level + 1,
                  parentName: item.config.name,
                  readOnly: readOnly
                }"
              ></ng-container>
            </div>
          }
          @if (itemTemplate.attachments) {
            <div class="flex h-min">
              <div class="flex min-h-[192px] flex-1">
                <snt-attachments></snt-attachments>
              </div>
            </div>
          }
        </div>
      </dx-tab-panel>
    }
  </div>
</div>
